import React from 'react'
import { MAX_IMAGES_TO_DISPLAY } from '@/constants'
import { getAssetUrl } from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import * as S from '../AccountStandingOrders.styles'

type StandingOrdersItemImageType = {
  image: string
  altText: string
  showOverlay: boolean
  productQty: number
}

const StandingOrdersItemImage = ({
  image,
  altText,
  showOverlay,
  productQty
}: StandingOrdersItemImageType) => {
  const itemImage =
    image || getAssetUrl('static/img/fallback-product-image.png')

  return (
    <div className={S.ItemImageWrapper}>
      <img alt={altText} src={itemImage} className={S.ItemImage} />
      {showOverlay && (
        <div className={S.ItemImageOverlayInfo}>
          +{1 + productQty - MAX_IMAGES_TO_DISPLAY}
        </div>
      )}
    </div>
  )
}

export default StandingOrdersItemImage
